import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { userModel } from '../models/userModel.model';

@Injectable()
export class AppService {
  private apiBaseUrl: string = '';
  private token: string = '';
  TOKEN_NAME: string = 'BWCExemptionToken';

  constructor(http: HttpClient, @Inject('environment') environment: any) {
    // Verify that the apiURL is in the environment variables
    if (
      environment.apiUrl === undefined ||
      environment.apiUrl === null ||
      environment.apiUrl === ''
    ) {
      throwError('WebAPI Value not set in the environment variables');
    }

    this.apiBaseUrl = environment.apiUrl;

    // make sure the apiBaseURL ends with a wack
    if (this.apiBaseUrl.endsWith('/') === false) {
      this.apiBaseUrl = this.apiBaseUrl.concat('/');
    }
  }

  public getEndpoint(route: string) {
    return `${this.apiBaseUrl}${route}`;
  }

  public gethttpOptions() {
    const headers = new HttpHeaders()
      .set('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, DELETE')
      .set('Access-Control-Allow-Origin', '*')
      .set('content-type', 'application/x-www-form-urlencoded')
      .set('content-type', 'application/json')
      .set('Authorization', `bearer ${this.getAuthorizationToken()}`);
      const options = {
        headers: headers };
      return options;
  }

  public gethttpOptionsFormDataContent() {
    const headers = new HttpHeaders()
      .set('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, DELETE')
      .set('Access-Control-Allow-Origin', '*')
      .set('Authorization', `bearer ${this.getAuthorizationToken()}`);
      return headers;
  }
  getAuthorizationToken(): string | null {
    // We will replace this with however we store the JWT Token
    console.log("Token");
    return this.getUser().token;
  }

  getUser(): userModel {
    let userInfo = localStorage.getItem(this.TOKEN_NAME);
    if (userInfo) {
      return JSON.parse(userInfo);
    }
    return new userModel();
  }
}
